import { isObject } from "./primitive-types.js";

export type AnyHTMLInputElementType =
  | HTMLInputElement
  | HTMLSelectElement
  | HTMLTextAreaElement;

export function isAnyHTMLInputElementType (value: unknown): value is AnyHTMLInputElementType {
  return isObject(value) && (
    (value instanceof HTMLInputElement) ||
    (value instanceof HTMLSelectElement) ||
    (value instanceof HTMLTextAreaElement));
}